import React from 'react';
import ErrorLayout from '../../components/ErrorLayout';

const Unauthorized = () => (
  <ErrorLayout 
    code={401} 
    title="Unauthorized" 
    message="You need to be logged in to access this page. Please log in to continue." 
    icon="pi pi-lock" 
    color="#f39c12" 
  />
);
export default Unauthorized;